import { render, staticRenderFns } from "./moreRooms.vue?vue&type=template&id=af1c3b5e&scoped=true"
import script from "./moreRooms.vue?vue&type=script&lang=js"
export * from "./moreRooms.vue?vue&type=script&lang=js"
import style0 from "./moreRooms.vue?vue&type=style&index=0&id=af1c3b5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af1c3b5e",
  null
  
)

export default component.exports